export default "__VITE_ASSET__B0SPAp0B__"